<script setup lang="ts">
type DocueEntityType = 'document' | 'folder' | 'template'

const props = defineProps<{
  id: string
  type: DocueEntityType
}>()
defineSlots<{
  default: () => unknown
}>()

const links = useLinks()

const entityConfig = computed(() => ({
  document: {
    icon: 'docue:file-05',
    to: links.document(props.id),
  },
  folder: {
    icon: 'docue:folder',
    to: links.folder(props.id),
  },
  template: {
    icon: 'docue:template',
    to: links.template(props.id),
  },
})[props.type])
</script>

<template>
  <NuxtLink
    :to="entityConfig.to"
    class="
      group/entity not-prose inline-flex h-6 max-w-full cursor-pointer items-center gap-1 rounded-md
      border border-neutral-200 bg-neutral-50 px-1.5 align-middle text-xs font-medium leading-none
      text-neutral-700 no-underline transition-colors hover:border-neutral-300 hover:bg-neutral-100
      hover:text-neutral-900
      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-400
      focus-visible:ring-offset-1
    "
  >
    <UiIcon
      :name="entityConfig.icon"
      aria-hidden="true"
      class="
        size-3.5 shrink-0 text-neutral-500 transition-colors
        group-hover/entity:text-neutral-700
      "
    />
    <span class="truncate">
      <slot />
    </span>
  </NuxtLink>
</template>
